import React from 'react';
import { useRouter } from 'next/router';

import confetti from '@/assets/launch/luckymint/confetti.png';

interface ILuckyMintCongratulationProps {
  roundId: number | undefined;
  allocatedDollarAmount: number | undefined;
}

const LuckyMintCongratulation: React.FC<ILuckyMintCongratulationProps> = ({
  roundId,
  allocatedDollarAmount,
}) => {
  const router = useRouter();

  if (!allocatedDollarAmount) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center gap-5 rounded-3xl bg-neutral-900 px-10 py-6 text-white md:flex-row md:gap-10">
      <img src={confetti.src} className="w-[72px]" alt="" />
      <div className="flex flex-col items-center justify-center gap-2">
        <div className="whitespace-pre-wrap text-center text-2xl font-semibold md:text-[28px] md:leading-9">
          Congratulations to the round #{roundId} winners for winning{' '}
          <span className="launchBg">${allocatedDollarAmount}</span>
        </div>
        <div
          className="cursor-pointer text-base font-normal underline hover:text-neutral-400"
          onClick={() => {
            router.push('/luckymint');
          }}
        >
          Learn More
        </div>
      </div>
      <img src={confetti.src} className="hidden w-[72px] md:block" alt="" />
    </div>
  );
};

export default LuckyMintCongratulation;
